import { storeToRefs } from 'pinia';
import { nextTick } from 'vue';
import OrderAPI from '@/apps/order/classes/api/OrderAPI';
import { useOrdersCreateCalculatorStore, useOrdersCreateDataPreparedStore, useOrdersCreateFormDataStore } from '@/apps/order/stores/ordersCreate';
import DataPreparedParamsInterface from '@/apps/order/interfaces/ordersCreate/DataPreparedParamsInterface';

let alreadyFetched = false;

const hasDataPreparedStepPayment = async (): Promise<void> => new Promise<void>(
  (resolve, reject) => {
    nextTick(async () => {
      try {
        const dataPreparedStore = useOrdersCreateDataPreparedStore();
        const { dataPayment } = storeToRefs(dataPreparedStore);

        const dataCalculatorPreparedStore = useOrdersCreateCalculatorStore();
        const { formData } = storeToRefs(dataCalculatorPreparedStore);

        const formDataStore = useOrdersCreateFormDataStore();
        const { selectedTariffs } = storeToRefs(formDataStore);

        if (dataPayment.value !== undefined) {
          resolve();
          return;
        }

        if (!alreadyFetched) {
          const params: DataPreparedParamsInterface = {};
          if (formData.value.salesPartnerNumber) {
            params.salesPartnerNumber = formData.value.salesPartnerNumber;
          }

          // SEPA-only for Fiber: pass product_id when an internet tariff is selected; commodity unchanged.
          const internetTariff = Object.values(selectedTariffs.value || {})
            .find((tariff: any) => tariff?.category?.key === 'internet');
          if (internetTariff?.id) {
            params.product_id = internetTariff.id;
          }

          await OrderAPI.fetchDataPreparedStepPayment(params).then((data) => {
            dataPayment.value = data;
          });

          alreadyFetched = true;
        }

        if (dataPayment.value === undefined) {
          reject(new Error('missing data prepared'));
          return;
        }

        resolve();
      } catch (e) {
        reject(new Error(['fetch data prepared failed', e].join(' ')));
      }
    });
  },
);

export default hasDataPreparedStepPayment;
